import { createBrowserRouter } from "react-router-dom";
import Home from "../components/Home/Home";
import QuizDetails from "../components/QuizDetails/QuizDetails";
import Statistics from "../components/Statistics/Statistics";
import Main from "../layouts/Main";
import Blogs from "./../components/Blogs/Blogs";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Main></Main>,
    children: [
      {
        path: "/",
        loader: () => fetch("https://openapi.programming-hero.com/api/quiz"),
        element: <Home></Home>,
      },
      {
        path: "/home",
        loader: () => fetch("https://openapi.programming-hero.com/api/quiz"),
        element: <Home></Home>,
      },
      {
        path: "/home/:id",
        loader: ({ params }) =>
          fetch(`https://openapi.programming-hero.com/api/quiz/${params.id}`),
        element: <QuizDetails></QuizDetails>,
      },
      {
        path: "/statistics",
        loader:()=>fetch('https://openapi.programming-hero.com/api/quiz'),
        element: <Statistics></Statistics>,
      },
      {
        path: "/blogs",
        element: <Blogs></Blogs>,
      },
    ],
  },
  {
    path: "*",
    element: (
      <div className="text-danger text-center mt-5">
        <h1 className="font-bolder">404</h1>
        <h2 className="font-bolder">This route is not found!</h2>
      </div>
    ),
  },
]);
